import RMClustersForSummary from './RMClusters'
export default RMClustersForSummary
